export default __webpack_public_path__ + "static/media/post.44861142.jpeg";